import { Checkbox, ProgressIndicator, Text, TextLink } from '@oneaudi/unified-web-components';
import { VATConfig } from '~/app/market-config';
import placeholder from '~/assets/icons/placeholder.svg';
import { Disclaimer } from '~/components/disclaimer/disclaimer';
import { ItemCardStyle } from '~/components/item-card/styles/item-card-style';
import { Prices } from '~/components/prices';

import { AccessoriesItem } from '~/graphql/mapper/map-accessories';
import { DATA_TEST_ID } from '~/test/data-test-id';
import { isDisclaimerAvailable } from '~/utils/date';

export type CardItemInfo = AccessoriesItem & {
	disabled: boolean;
	selected: boolean;
	loading: boolean;
	standard: boolean;
	hasDetails: boolean;
};

interface ItemCardProps {
	item: CardItemInfo;
	feature: VATConfig;
	standardPriceText: string;
	onChange: (status: boolean, oldStatus: boolean) => void;
	moreInformation: {
		title: string;
		onMoreInformation: (event: React.MouseEvent) => void;
	};
}

export const ItemCard = ({ item, onChange, moreInformation, standardPriceText, feature }: ItemCardProps) => {
	return (
		<ItemCardStyle data-testid={DATA_TEST_ID.SELECTION_CARD_CONTAINER}>
			<img loading="lazy" src={item.imageUrl || placeholder} alt={item.name || ''} />
			<div className="equipment-content">
				<Checkbox
					label={item.name}
					name={item.name}
					id={`equipment-checkbox-${item.pr7}`}
					disabled={item.disabled}
					value={item.pr7}
					checked={item.selected}
					onChange={() => onChange(!item.selected, item.selected)}
					data-testid={DATA_TEST_ID.SELECTION_CARD_CHECKBOX}
				/>
				{item.totalPrice &&
					(item.standard ? (
						<Text tag="p" variant={{ type: 'copy', order: '2', style: 'normal' }}>
							{standardPriceText}
						</Text>
					) : (
						<Prices totalPrice={item.totalPrice} monthlyRate={item.monthlyRate} vatConfig={feature} />
					))}
				{item.texts?.disclaimerText &&
					isDisclaimerAvailable(item.texts.disclaimerStartDate, item.texts.disclaimerEndDate) && (
						<div className="disclaimer-wrapper">
							<Disclaimer
								type="item"
								headline={item.texts.disclaimerHeadline || ''}
								content={item.texts.disclaimerText}
							/>
						</div>
					)}
				{item.hasDetails && (
					<TextLink
						aria-label="more information"
						className="more-info"
						onClick={moreInformation.onMoreInformation}
						size="sm"
						variant="standalone">
						{moreInformation.title}
					</TextLink>
				)}
			</div>

			{item.loading && (
				<div className="loading-skeleton">
					<ProgressIndicator size={'lg'} variant={'spinner'} type={'infinite'} />
				</div>
			)}
		</ItemCardStyle>
	);
};
